import { render, staticRenderFns } from "./consult.pug?vue&type=template&id=02253fe0&lang=pug&"
import script from "./consult.ts?vue&type=script&lang=ts&"
export * from "./consult.ts?vue&type=script&lang=ts&"
import style0 from "./consult.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports